import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import enBasketRecommendation from './locales/en/basketRecommendation.json';
import deBasketRecommendation from './locales/de/basketRecommendation.json';
import enPostingCard from './locales/en/postingCard.json';
import dePostingCard from './locales/de/postingCard.json';
import enPosts from './locales/en/posts.json';
import dePosts from './locales/de/posts.json';
import enMenu from './locales/en/menu.json';
import deMenu from './locales/de/menu.json';
import enPharmacyProfile from './locales/en/pharmacyProfile.json';
import dePharmacyProfile from './locales/de/pharmacyProfile.json';

// Detect initial language
const detectInitialLanguage = () => {
    const LANGUAGE_COOKIE_KEY = 'preferred_language';
    const cookieLanguage = Cookies.get(LANGUAGE_COOKIE_KEY);
    
    console.log('🚀 i18n initialization debug:');
    console.log('- navigator.language:', navigator.language);
    console.log('- cookieLanguage:', cookieLanguage);
    
    if (cookieLanguage) {
        console.log('- Using cookie language:', cookieLanguage);
        return cookieLanguage;
    }
    
    // Get browser's language (returns language code like 'en-US' or 'de-DE')
    const browserLang = navigator.language.toLowerCase().split('-')[0];
    // Set to German if browser language is German, otherwise default to English
    const detectedLanguage = browserLang === 'de' ? 'de' : 'en';
    console.log('- browserLang extracted:', browserLang);
    console.log('- detectedLanguage:', detectedLanguage);
    
    return detectedLanguage;
};

const initialLanguage = detectInitialLanguage();

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
                menu: enMenu,
                basketRecommendation: enBasketRecommendation,
                postingCard: enPostingCard,
                posts: enPosts,
                pharmacyProfile: enPharmacyProfile,
            },
            de: {
                translation: deTranslation,
                menu: deMenu,
                basketRecommendation: deBasketRecommendation,
                postingCard: dePostingCard,
                posts: dePosts,
                pharmacyProfile: dePharmacyProfile,
            },
        },
        lng: initialLanguage,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;